export default function callNativeRestorePurchases() {
  if (window.webkit) {
    window.webkit.messageHandlers.restorePurchases.postMessage({});
  }
}
